import React from "react";
import { Link } from "gatsby";

const whyChooseUs = {
  benefits: [
    {
      title: "Expertise in Start-up Technologies",
      description:
        "In-depth understanding and experience in latest technologies and methodologies that cater to the unique needs of startups",
    },
    {
      title: "Scalability and Agility",
      description:
        "Scalable, flexible and agile software development solutions that can adapt to the fast-paced nature of startups",
    },
    {
      title: "Cost-effective Solutions",
      description:
        "Cost-effective solutions that are tailored to the budget and resources of the startup, providing value for money",
    },
  ],
};

const WhyChooseUs = () => {
  return (
    <section id="why-choose-us" className="section-spacing bg-white pb-0">
      <div className="container">
        <div className="row">
          <div className="col-lg-7 mt-0 mt-md-5 mb-10">
            <div className="mb-5 d-flex align-items-center">
              <img
                src="/images/favicon.webp"
                className="img-fluid ms-1 me-2"
                style={{
                  width: "60px",
                }}
                alt="alternative"
              />
              <h2 className="fs-2 m-0 lh-normal bold fst-normal text-uppercase">
                Why do best engineers choose working with <br />
                <span className="text-blue">Hanzala</span>
              </h2>
            </div>

            {whyChooseUs.benefits.map((benefit, index) => (
              <div className="d-flex mb-3 ms-2" key={index}>
                <span className="fs-4 bg-toggle-darkLight shadow-sm rounded-pill py-2 px-3 me-4 h-100">
                  {index + 1}
                </span>
                <div>
                  <h4 className="fs-4 m-0 lh-normal semibold fst-normal">
                    {benefit.title}
                  </h4>
                  <p className="opacity-75 fs-5">{benefit.description}</p>
                </div>
              </div>
            ))}

            <div className="ms-2 ms-sm-5 ps-2 ps-sm-3">
              <Link
                className="btn-solid-lg rounded fw-bold px-5 py-4 fs-5"
                to="https://meetings.hubspot.com/hanzala"
                role="button"
                target="_blank"
              >
                Book a call
              </Link>
            </div>
          </div>
          {/* <div className="col-md-8 col-lg-5 mx-auto">
            <img
              src="/images/home/why-choose-us-bg.webp"
              className="img-fluid"
              alt="alternative"
            />
          </div> */}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
